import React from "react";
import PropTypes from "prop-types"
import {Table} from 'antd';
import {NavLink} from "react-router-dom"
import {defaultPagination} from "../../util/Util"


const ImportStatisticsTable = ({dataSource, onSelectChange, loading}) => {
    const columns = [
        {title: 'Type', dataIndex: 'type', render: (text) => <NavLink to={`/import/${text}`}>{text}</NavLink>}
    ];

    const rowSelection = {
        type: 'radio',
        onChange: (selectedRowKeys) => {
            if (selectedRowKeys.length > 0) onSelectChange(selectedRowKeys[0])
        }
    };

    return (
        <Table
            dataSource={dataSource}
            loading={loading}
            columns={columns}
            bordered
            rowKey={record => record.id}
            rowSelection={rowSelection}
            pagination={defaultPagination()}
        />
    );
};
ImportStatisticsTable.propTypes = {
    dataSource: PropTypes.array.isRequired,
    onSelectChange: PropTypes.func,
    compact: PropTypes.bool.isRequired
};

export default ImportStatisticsTable



// WEBPACK FOOTER //
// ./src/js/browse/import/ImportStatisticsTable.js